import React, { useContext } from 'react'
import { InputElement } from '../../../../HtmlComponents/InputElement'
import { RegistrationFormContext } from './types'
import { useSelector } from 'react-redux'
import { State } from '../../../../redux/store'

const HeaderRegForm = () => {
  const  {
    RegNo, setRegNo,
    inscriptionDate, setInscriptionDate,
  } = useContext(RegistrationFormContext)
  
  const { userData } = useSelector((state: State) => state.login)

  if(userData.user) {
    return (
      <section className='col-span-2 rounded shadow-lg p-4 mb-4 border'>
        <h1 className='text-center text-bold border-2 border-black p-2'>cadre reserve au conseil national de l'ordre</h1>
        <div className='grid md:grid-cols-2 gap-2'>
          <InputElement type="date" name="Date D'inscription" placeholder="Date D'inscription" value={inscriptionDate} setValue={setInscriptionDate} />
          <InputElement name="Numero de l'inscription" placeholder="Numero de l'inscription" value={RegNo} setValue={setRegNo} />  
        </div>
      </section>
    )
  }
  return <></>
}

export default HeaderRegForm